import * as React from "react";
import { getRowFields } from "./data";

var createIndexArray = function createIndexArray(n) {
  return Array.from({
    length: n
  }, function (_, i) {
    return i;
  });
};

var generateTableRows = function generateTableRows(fieldsToRender) {
  var numberofRows = createIndexArray(fieldsToRender.length).filter(function (index) {
    return index % 2 === 0;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, numberofRows.map(function (index) {
    var field = fieldsToRender[index];
    var field2 = fieldsToRender[index + 1];
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, field.label), /*#__PURE__*/React.createElement("td", null, field.value), field2 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", {
      scope: "row"
    }, field2.label), /*#__PURE__*/React.createElement("td", null, field2.value)));
  }));
};

var PaymentMethodDetails = function PaymentMethodDetails(props) {
  var poliza = props.poliza;
  /* 
  -> Forma de pago - string - tipo_de_pago
  If tipo_de_pago === "CONTADO"
    -> Pagado previamente? - boolean - is_prepaid
    -> Pago Transferencia? - boolean - show_transfer_payment
  If tipo_de_pago !== "ONE CLICK" or tipo_de_pago === "AVISO DE VENCIMIENTO"
    -> Número cuotas - integer - number_of_cuotes
    -> Valor cuotas - float - first_cuote
    -> Fecha primer Vencimiento - date - first_expiration_date
    ONLY IF tipo_de_pago === "AVISO DE VENCIMIENTO"
      -> Pago Transferencia? - boolean - show_transfer_paymentF
  */

  var rowFields = getRowFields(poliza);
  var fieldsFiltered = rowFields.filter(function (field) {
    var _field$tipo_de_pagos;

    return field === null || field === void 0 ? void 0 : (_field$tipo_de_pagos = field.tipo_de_pagos) === null || _field$tipo_de_pagos === void 0 ? void 0 : _field$tipo_de_pagos.some(function (item) {
      return item === (poliza === null || poliza === void 0 ? void 0 : poliza.tipo_de_pago);
    });
  });
  return /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, generateTableRows(fieldsFiltered));
};

export default PaymentMethodDetails;